
import common from './common'
import debugHelper from '../../util/debug'
import msgbus from '../../msgBus'



var msgbox = {

  /**
     * 计算消息盒子未读消息数量，并设置消息盒子/app角标
     * @param {*} vm
     * @param {*} funcList
     */
  funcFetchMsgForBoxBadge: function (vm, funcList, voiceRemain) {
    console.log('调试代码')
    debugHelper.log('funcFetchMsgForBoxBadge: 计算未读消息数量')

    // 注意：当前系统目前不知道有多少条新消息

    // 获取系统消息未读数量
    // var messageUnread = msgbus.vm.getMessageUnreadNum()
    // 设置消息盒子角标
    // msgbus.vm.setMessageTips({ value: messageUnread })
    // 设置app角标的红点数量
    // window.cordova.plugins.notification.badge.clear()
    // window.cordova.plugins.notification.badge.set(messageUnread)

    // 目前只有极光推送才会调用当前接口，有推送过来，就说明有新消息
    msgbus.vm.setMessageTips({ value: 100 }) // > 99 显示红点,目前不知道有多少条新消息，因此显示纯红点

    // 设置app角标的红点数量
    // (注：1）android平台只能由极光推送给手机底层通知模块，进而设置角标，极光收到几条显示几，非自主设置，当前语句无效，因此屏蔽安卓平台；
    //      2）iOS平台可以自主根据实际新消息数设置角标,当前语句有效，但是又由于没有具体的消息数量，所有set(1) 标识有新消息；)
    if (msgbus.vm.getPlatform() !== 'browser' && msgbus.vm.getPlatform() !== 'android') {
      window.cordova.plugins.notification.badge.clear()
      window.cordova.plugins.notification.badge.set(1)
    }

    if (funcList) {
      common.callNextFunc(vm, funcList)
    }
  },
}

export default msgbox